import type { TFunction } from 'i18next'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { Language } from 'src/lib/utils'

import { getResource } from './getResource'

export const initI18n = async (language: Language): Promise<TFunction<'translation', undefined>> =>
  i18n.use(initReactI18next).init({
    debug: process.env.NODE_ENV === 'development',
    resources: {
      ...(await Promise.all([getResource(language), getResource(Language.PT)])).reduce(
        (resources, resource) => ({ ...resources, ...resource }),
        {}
      )
    },
    lng: language,
    load: 'currentOnly',
    fallbackLng: [Language.EN, Language.PT],
    interpolation: {
      escapeValue: false
    },
    returnNull: false,
    returnEmptyString: false
  })

export default i18n
